import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useToast, ModalBody, FormItem, ModalFooter, Input, Switch, Button, Modal, ModalTitle, Textarea } from "@vertesia/ui/core";
import { SelectContentType } from "../types/SelectContentType";
import { useNavigate } from "@vertesia/ui/router";
import { useUserSession } from "@vertesia/ui/session";
import { useState } from "react";
import { useUITranslation } from '../../../i18n/index.js';
export function CreateCollectionForm({ onClose, redirect = true, onAddToCollection }) {
    const navigate = useNavigate();
    const toast = useToast();
    const { t } = useUITranslation();
    const [isProcessing, setProcessing] = useState(false);
    const { client } = useUserSession();
    const [payload, setPayload] = useState({
        dynamic: false,
        name: "",
        description: "",
    });
    function setPayloadProp(name, value) {
        setPayload({
            ...payload,
            [name]: value,
        });
    }
    const onCreate = () => {
        if (!payload?.name || !payload.name.trim()) {
            toast({
                title: t('type.nameRequired'),
                description: t('store.pleaseProvideName'),
                status: "error",
                duration: 5000,
            });
            return;
        }
        payload.name = payload.name.trim();
        if (payload.description) {
            payload.description = payload.description.trim();
        }
        if (payload.dynamic == null) {
            payload.dynamic = false;
        }
        setProcessing(true);
        client.store.collections
            .create(payload)
            .then((r) => {
            onClose();
            toast({
                title: t('store.collectionCreated'),
                description: `Collection "${r.name}" created successfully`,
                status: "success",
                duration: 3000,
            });
            if (redirect)
                navigate(`/collections/${r.id}`);
            if (onAddToCollection) {
                onAddToCollection(r.id);
            }
        })
            .catch((err) => {
            toast({
                title: t('store.failedToCreateCollection'),
                description: err.message,
                status: "error",
                duration: 5000,
            });
        })
            .finally(() => setProcessing(false));
    };
    return (_jsxs(_Fragment, { children: [_jsx(ModalBody, { children: _jsxs("form", { onSubmit: (e) => e.preventDefault(), children: [_jsx(FormItem, { label: t('type.name'), required: true, children: _jsx(Input, { type: "text", value: payload.name || "", onChange: (value) => setPayloadProp("name", value) }) }), _jsx(FormItem, { label: t('type.description'), className: "mt-2", children: _jsx(Textarea, { value: payload.description || "", onChange: (ev) => setPayloadProp("description", ev.target.value) }) }), _jsx(FormItem, { label: t('store.dynamicCollection'), className: "mt-2", direction: "row", description: t('store.dynamicCollectionDescription'), children: _jsx(Switch, { value: payload.dynamic || false, onChange: (value) => setPayloadProp("dynamic", value) }) }), !payload.dynamic &&
                            _jsx(FormItem, { label: t('store.allowedContentTypes'), className: "mt-4", description: t('store.allowedContentTypesOptionalDescription'), children: _jsx(SelectContentType, { defaultValue: payload.allowed_types || null, onChange: (v) => {
                                        if (Array.isArray(v)) {
                                            setPayloadProp("allowed_types", v.map(type => type.id));
                                        }
                                        else {
                                            setPayloadProp("allowed_types", v ? [v.id] : []);
                                        }
                                    }, isClearable: true, multiple: true }) }), _jsx(FormItem, { label: t('store.contentType'), className: "mt-2", description: t('store.typeDescription'), children: _jsx(SelectContentType, { defaultValue: payload.type || null, onChange: (v) => {
                                    if (Array.isArray(v)) {
                                        setPayloadProp("type", v.length > 0 ? v[0].id : null);
                                    }
                                    else {
                                        setPayloadProp("type", v?.id || null);
                                    }
                                }, isClearable: true }) })] }) }), _jsx(ModalFooter, { children: _jsx(Button, { isDisabled: isProcessing, onClick: onCreate, children: t('store.createCollection') }) })] }));
}
export function CreateCollectionModal({ isOpen, onClose }) {
    const { t } = useUITranslation();
    return (_jsxs(Modal, { onClose: onClose, isOpen: isOpen, children: [_jsx(ModalTitle, { children: t('store.createACollection') }), _jsx(CreateCollectionForm, { onClose: onClose })] }));
}
//# sourceMappingURL=CreateCollection.js.map